import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button/Button";
import { CircularProgress } from "@mui/material";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import Grid from "@mui/material/Grid";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getPricingById, updatePricing } from "../../apis/pricing";
import { getHelperPricingById, updateHelperPricing } from "../../apis/helperPricing";

const EditHelperPricing = () => {
  const { indice, indices } = useSelector((state: any) => state.helperPricingReducer);
  const dispatch = useDispatch();
  const [pricingData, setPricingData] = useState({ index: -1, data: indice, allPrices: indices });
  const navigate = useNavigate();
  let params = useParams();
  const [searchParams] = useSearchParams();
  const pricingId: string | undefined = params?.id;
  const packageSize: string | null = searchParams.get("type");
  const countryParam = searchParams.get("country");
  const cityParam = searchParams.get("city");
  const [loading, setLoading] = useState(false);

  const onHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPricingData((prevPriceData) => ({
      ...prevPriceData,
      data: {
        ...prevPriceData.data,
        [event.target.name]: event.target.value,
      },
    }));
  };

  const goToBack = () => {
    // Preserve country and city when navigating back
    const countryQuery = countryParam ? `?country=${countryParam}` : "";
    const cityQuery = cityParam ? `${countryQuery ? "&" : "?"}city=${encodeURIComponent(cityParam)}` : "";
    navigate(`/helper-pricing${countryQuery}${cityQuery}`);
  };

  const updatePricingData = async () => {
    const id = pricingId !== undefined ? pricingId : "";
    const indexToUpdate = pricingData.index;
    if (indexToUpdate !== -1) {
      pricingData.allPrices.price_list[indexToUpdate] = {
        ...pricingData.allPrices.price_list[indexToUpdate],
        ...pricingData.data,
      };
    }

    if (id) {
      const response: any = await updateHelperPricing(id, pricingData.allPrices);
      if (response.status) {
        goToBack();
      }
    }
  };

  const getData = async () => {
    setLoading(true);
    const id = pricingId !== undefined ? pricingId : "";
    if (id) {
      const data: any = await getHelperPricingById(id);
      if (data) {
        const index = data?.price_list.findIndex((item: any) => item.package_size === packageSize);
        setPricingData({ index, data: data?.price_list[index], allPrices: data });
      } else {
        goToBack();
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  console.log("pricingData", pricingData);
  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box style={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "200px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <div
                style={{
                  marginBottom: "20px",
                }}
              >
                <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: "20px" }}>
                  Update Pricing Details
                </Typography>
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                  }}
                >
                  <Box
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          label="Package Size"
                          name="package_size"
                          variant="outlined"
                          value={pricingData.data?.package_size || ""}
                          InputProps={{
                            readOnly: true,
                          }}
                          style={{ marginBottom: "10px", width: "100%" }}
                        />
                      </Grid>

                      <Grid item>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          placeholder="Price per KM"
                          label="Price per KM"
                          name="price_per_km"
                          variant="outlined"
                          style={{ marginBottom: "10px", width: "100%" }}
                          value={pricingData.data?.price_per_km}
                          onChange={onHandleChange}
                        />
                      </Grid>

                      <Grid item>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          placeholder="Price per Min"
                          label="Price per Min"
                          name="price_per_min"
                          variant="outlined"
                          value={pricingData.data?.price_per_min}
                          style={{ marginBottom: "10px", width: "100%" }}
                          onChange={onHandleChange}
                        />
                      </Grid>

                      <Grid item>
                        <TextField
                          id="outlined-basic"
                          size="small"
                          placeholder="Base Price"
                          label="Base Price"
                          name="base_price"
                          variant="outlined"
                          value={pricingData.data?.base_price}
                          style={{ marginBottom: "10px", width: "100%" }}
                          onChange={onHandleChange}
                        />
                      </Grid>

                    </Grid>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      alignItem: "center",
                    }}
                  >
                    <Button
                      style={{ marginRight: "4px", backgroundColor: "gray" }}
                      variant="contained"
                      onClick={goToBack}
                    >
                      Cancel
                    </Button>
                    <Button variant="contained" onClick={updatePricingData}>
                      Update
                    </Button>
                  </Box>
                </Box>
              </div>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EditHelperPricing;
